<template>
  <vue-content-loading 
    :width="300" 
    :height="lines * 14"
  >
    <template v-for="(_, index) in lines">
      <circle
        v-if="!hideCircle" 
        :cy="6 + (index * 14)"
        cx="6"
        r="6"
      />
      <rect
        :x="hideCircle ? 0 : 18"
        :y="1 + (index * 14)"
        rx="4"
        ry="4"
        width="350"
        height="10"
      />
    </template>
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading'
export default {
  name: 'AppSkeletonList',
  components: {
    VueContentLoading
  },
  props: {
    hideCircle: {
      type: Boolean,
      default: false
    },
    lines: {
      type: Number,
      default: 7
    }
  }
}
</script>
